import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface FeatureItemProps {
  description: string;
  iconType: string;
  title: string;
}

export const FeatureItem = ({
  iconType,
  title,
  description,
}: FeatureItemProps) => (
  <div className="flex gap-3">
    <div className="mt-0.5 shrink-0">
      <div className="flex size-4 items-center justify-center">
        <Icon
          type={iconType}
          size={16}
          className="text-blue-600"
          useWithFillCurrentColor
        />
      </div>
    </div>
    <div>
      <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
      <Typography.BodySm color="text-subtle">{description}</Typography.BodySm>
    </div>
  </div>
);
